import PropTypes from 'prop-types';

export const getBudgetInputStyles = () => {
  const budgetDetailsContainer = {
    display: 'flex',
  };

  const dropdownContainer = {
    marginLeft: '12px',
  };

  const budgetInputContainer = {
    display: 'inline-block',
    flex: 1,
    maxWidth: '280px',
    '& input': {
      height: '32px',
    },
    '& [role=alert]': {
      display: 'none', // we use custom ErrorMessages component
    },
  };

  const isInvalid = {
    border: '1px solid #a4262c',
  };

  const inline = {
    display: 'inline-block',
    '& button': {
      display: 'flex',
      fontWeight: 200,
      width: '86px',
      height: '32px',
      lineHeight: '32px',
      textAlign: 'left',
    },
  };

  const budgetTitle = {
    fontSize: '14px',
    lineHeight: '19px',
    marginBottom: '7px',
    fontWeight: '600',
    '& label': {
      marginRight: '3px',
      padding: 'inherit',
    },
  };

  const inputText = {
    '-moz-appearance': 'textfield',

    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  };

  const currencyText = {
    fontWeight: 200,
    padding: '5px 0 0 10px',
  };

  const budgetInputError = {
    fontSize: 12,
    color: '#A80000',
  };

  return {
    budgetDetailsContainer,
    budgetInputContainer,
    budgetTitle,
    currencyText,
    dropdownContainer,
    inline,
    inputText,
    isInvalid,
    budgetInputError,
  };
};

export const classesProps = PropTypes.shape({
  budgetDetailsContainer: PropTypes.string,
  budgetInputContainer: PropTypes.string,
  budgetTitle: PropTypes.string,
  currencyText: PropTypes.string,
  dropdownContainer: PropTypes.string,
  inline: PropTypes.string,
  inputText: PropTypes.string,
  isInvalid: PropTypes.string,
});
